import { render } from "./component_button.vue?vue&type=template&id=e98d0c5c"
import script from "./component_button.vue?vue&type=script&lang=js"
export * from "./component_button.vue?vue&type=script&lang=js"

import "./component_button.vue?vue&type=style&index=0&id=e98d0c5c&lang=css"

import exportComponent from "/Users/patrikhubner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__